import type { OptionType } from '@innovamat/glimmer-components';
import { useEducationalPlansQuery } from '@innovamat/glow-api-client';
import { sortBy } from '@innovamat/radiance-utils';
import { useMemo } from 'react';
import { useOrganization } from './use-organization';

type Props = {
  filterOrderCourse?: number | undefined | null;
  enabled?: boolean;
};

function useEducationalPlans({ filterOrderCourse, enabled = true }: Props) {
  const { organization } = useOrganization();

  const { data, isLoading } = useEducationalPlansQuery(
    {
      regionCode: organization?.operativeRegion!,
      courseOrder: filterOrderCourse,
    },
    {
      enabled: !!organization && !!filterOrderCourse && enabled,
    }
  );

  const educationPlans = useMemo(
    () => data?.educationalPlans?.concat().sort(sortBy('courseOrder')) || [],
    [data]
  );

  const educationOptions: OptionType[] = useMemo(() => {
    return educationPlans.map((plan) => ({
      label: plan?.educationalPlanName!,
      value: plan?.id!,
    }));
  }, [educationPlans]);

  const getEducationalPlanByCourse = (courseId: string) => {
    return (
      educationPlans.find((ed) => ed?.courseId === courseId) ||
      educationPlans[0]
    );
  };

  return {
    educationOptions,
    educationPlans,
    isLoading,
    getEducationalPlanByCourse,
  };
}

export { useEducationalPlans };
